/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const updateWhatsAppTemplateDataSchema = z.object({
	bodyText: z.string(),
	exampleParameters: z.array(z.string()).nullable().optional().default([]),
})

export type UpdateWhatsAppTemplateDataSchema = z.infer<typeof updateWhatsAppTemplateDataSchema>
